<template>
  <div>

    <div class="row mb-3">
      <div class="col-md-6">
        <h5 class="mt-2">Últimas ações nesta conta</h5>
      </div>
      <div class="col-md-6 text-right">
        <button @click="find(true)" class="btn btn-primary ml-4"><RefreshCcwIcon/></button>
        <router-link tag="button" to="definitions?tab=events" class="btn btn-primary btn-xl ml-2">Ver todos</router-link>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <table class="table table-borderless table-border table-align table-h51">
          <tbody>
          <tr v-for="event in events" :key="event.id">
            <td v-html="event.htmlMessage"/>
            <td>
              <strong>{{ event.createdAt | date }}</strong>
              <br>
              <strong>{{ event.createdAt | hour }}</strong>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
  import EntityProxy from '@/models/EntityProxy'
  import GetAccount from '@/mixins/GetAccount'
  import ModelMapper from '@/mixins/ModelMapper'
  import { RefreshCcwIcon } from 'vue-feather-icons'

  export default {
    components: { RefreshCcwIcon },
    computed: {
      events() {
        return this.getModels || []
      }
    },
    created() {
      this.addOrderBy('created_at')
      this.fields.push('html_message', 'account_id', 'created_at')
      this.params.meta = false
      this.find()
    },
    data() {
      return {
        nameModel: 'Event',
      }
    },
    methods: {
    find(force) {
      const key = this.$name()

      const data = this.$ls.get(key)
      if (!force && data) {
        this.setModels(EntityProxy.build(data))
        return
      }

      this.asyncTemplateSelect({
        after: ({models}) => this.$ls.set(key, models, { minutes: 10 })
      })
    }
    },
    mixins: [ModelMapper, GetAccount],
    name: 'DashboardEvent'
  }
</script>

<style scoped>

</style>
